module.exports = __webpack_public_path__ + "static/media/accesss_token_flow.bb848474.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/developerApi/developerSdk/Authentication/accesss_token_flow.png
// module id = 1218
// module chunks = 0